import React from "react";

export enum KeyType {
  ENTER = "Enter",
  TAB = "Tab",
  ARROW_DOWN = "ArrowDown",
  ARROW_UP = "ArrowUp",
  ARROW_LEFT = "ArrowLeft",
  ARROW_RIGHT = "ArrowRight",
}

export const keyboardAction = (event: React.KeyboardEvent<Element>, key: KeyType, action: () => void) => {
  if (event.key === key) {
    event.preventDefault();
    action();
  }
};
